import { Outlet } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useGetActionsQuery } from "./actionsApiSlice";
import PulseLoader from "react-spinners/PulseLoader";
const ShowAction = () => {
  // const { actionId } = useParams()

  // const { action } = useGetActionsQuery("actionsList", {
  //     selectFromResult: ({ data }) => ({
  //         action: data?.entities[actionId]
  //     }),
  // })

  // if (!action ) return <PulseLoader color={"#FFF"} />



  return (
    <Outlet />
  );
};

export default ShowAction;
